export const getMeasure = (countryCode: string) => {
    let measure: 'km' | 'mi' = 'km';
    if (
        countryCode?.toUpperCase() === "US" ||
        countryCode?.toUpperCase() === "LR" ||
        countryCode?.toUpperCase() === "MM"
    ) {
        measure = 'mi';
    }
    return measure;
}